/**
 * Campaign Tracker Initialization Component
 *
 * This component initializes the campaign tracker hook which:
 * - Parses UTM parameters from the URL
 * - Manages the campaign cookie (create/update/delete)
 * - Handles consent changes via OneTrust
 *
 * Mount this component once at the app level (e.g., _app.tsx).
 *
 * Part of BEC-20520: Campaign Tracker with Salesforce
 */

import { useCampaignTracker } from '@/hooks/useCampaignTracker';
import { useRegionProvider } from '@/providers/RegionProvider';

/**
 * Initializes campaign tracking cookie management.
 * Renders nothing - purely for side effects.
 */
export const CampaignTrackerInit = () => {
  const { country } = useRegionProvider();

  // Initialize the campaign tracker hook
  // This handles UTM parsing, cookie management, and consent changes
  useCampaignTracker({ countryCode: country.code });

  return null;
};
